import { formatToCurrency } from "@/lib/utils";
import React from "react";

interface ExpenseCategoryCardProps {
  icon: React.ReactNode;
  label: string;
  total: number;
}

const ExpenseCategoryCard: React.FC<ExpenseCategoryCardProps> = ({
  icon,
  label,
  total,
}) => {
  return (
    <div className="bg-card shadow-sm rounded-lg p-4 border border-white">
      <div className="flex items-center space-x-2">
        {icon}
        <span className="font-medium text-foreground">{label}</span>
      </div>
      <div className="text-xl font-bold mt-2 text-foreground">
        {formatToCurrency(total)}
      </div>
    </div>
  );
};

export default ExpenseCategoryCard;
